// extracted by mini-css-extract-plugin
export default {"tabWrapper":"ItkJkIjsPaVsiFF6S9B5t","active":"_19BbUOcUo6e3AoviLzbqN7"};